import trueIcon from "../../images/home/appSection/true.png";
import DOMPurify from "dompurify";

const AppSection = (props) => {
  return (
    <div
      id="appSection"
      className="mx-5 md:mx-12 sm:-mt-10 md:-mt-20 md:pt-0 pb-14 flex flex-col md:h-[50rem] place-items-end"
    >
      <h1 className="mt-2 sm:mt-[3rem] text-lg sm:text-2xl md:text-5xl text-[#15363A] w-[100%] text-left md:text-center pl-[2.5rem] sm:pl-[4.6rem] md:pl-36 font-bold">
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(props.data.bigTitle),
          }}
        />
      </h1>
      <div
        id="bgAppSection"
        className="pl-10 md:pl-0 relative pb-10 md:pb-0 w-[100%] md:w-[80%] h-[50%] mt-6 sm:mt-[2rem] md:mr-5"
      >
        <div className="hidden md:flex absolute bg-[#FFC400] rounded-full w-[35rem] h-[35rem] -ml-[18rem] -mt-32">
          <div className="flex">
            <img
              className="hover:z-50 w-[20rem] h-[30rem] mt-[4rem]"
              src={props.data.imgLeft}
              alt="no img"
            />
            <img
              className="hover:z-50 w-[20rem] h-[35rem] -ml-[13rem] z-40"
              src={props.data.imgCenter}
              alt="no img"
            />
            <img
              className="hover:z-50 w-[18rem] h-[30rem] -ml-[10rem] mt-[3rem] z-30"
              src={props.data.imgRight}
              alt="no img"
            />
          </div>
        </div>
        <h2 className="md:pl-[20rem] pt-[2rem] text-white text-[10px] sm:text-sm md:text-xl pr-10">
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.data.descTop),
            }}
          />
        </h2>
        <div className="md:pl-[20rem] pt-7 pr-10 text-white text-[10px] sm:text-sm md:text-lg">
          <div className="flex flex-row gap-3">
            <img
              className="w-3 md:w-4 h-3 md:h-4 mt-[0.27rem] md:mt-[0.42rem]"
              src={trueIcon}
              alt="no img"
            />
            <h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.data.features.f1),
                }}
              />
            </h2>
          </div>
          <div className="flex flex-row gap-3 pt-1 md:pt-[0.4rem]">
            <img
              className="w-3 md:w-4 h-3 md:h-4 mt-[0.27rem] md:mt-[0.42rem]"
              src={trueIcon}
              alt="no img"
            />
            <h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.data.features.f2),
                }}
              />
            </h2>
          </div>
          <div className="flex flex-row gap-3 pt-1 md:pt-[0.4rem]">
            <img
              className="w-3 md:w-4 h-3 md:h-4 mt-[0.27rem] md:mt-[0.42rem]"
              src={trueIcon}
              alt="no img"
            />
            <h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.data.features.f3),
                }}
              />
            </h2>
          </div>
          <div className="flex flex-row gap-3 pt-1 md:pt-[0.4rem]">
            <img
              className="w-3 md:w-4 h-3 md:h-4 mt-[0.27rem] md:mt-[0.42rem]"
              src={trueIcon}
              alt="no img"
            />
            <h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.data.features.f4),
                }}
              />
            </h2>
          </div>
        </div>
        <h2 className="md:pl-[20rem] pt-[1.5rem] sm:pt-[2.5rem] text-white  text-[12px] sm:text-sm md:text-xl pr-10">
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.data.descBottom),
            }}
          />
        </h2>
        <div className="flex flex-row gap-4 md:pl-[20rem] pt-[1rem]">
          <a href={props.data.googlePlayLink}>
            <img
              className="hover:opacity-50 w-24 md:w-40 place-self-end"
              src={props.data.googlePlayImg}
              alt="no img"
            />
          </a>
          <a href={props.data.appStoreLink}>
            <img
              className="hover:opacity-50 w-24 md:w-40"
              src={props.data.appStoreImg}
              alt="no img"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppSection;
